import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SwitchOn from '../adminIcons/SwitchOn.svg'
import BackIcon from '../adminIcons/BackIcon.svg'
import SwitchOff from '../adminIcons/SwitchOff.svg'
import { getCategory, getCategoryTags, editCategory } from '../../actions/AdminCategoryActions';
import { useParams, useNavigate } from 'react-router-dom'
import CategoryTagItem from './CategoryTagItem';
import AddTagComponent from './AddTagComponent';
import Attach from '../adminIcons/Attach.svg'

const EditCategory = (props) => {

    const dispatch = useDispatch()
    const [imageFile, setImageFile] = useState()
    const [imageURL, setImageUrl] = useState()
    const [description, setDescription] = useState("")
    const [longDescription, setLongDescription] = useState("")

    const navigate = useNavigate()

    const {category_id} = useParams()

    const {category, loadingCategory, errorCategory} = useSelector(state=>state.adminCategories)
    const {categoryTags, loadingCategoryTags, errorCategoryTags} = useSelector(state=>state.categoryTags)

    const [statusOn, setStatusOn] = useState(0)
    const [title, setTitle] = useState("")


    useEffect(()=>{
        dispatch(getCategory(category_id))
        dispatch(getCategoryTags(category_id))
    },[])

    useEffect(()=>{
        if(category){
            setTitle(category.title)
            setStatusOn(category.status)
            setDescription(category.description)
            setLongDescription(category.description_long)
            setImageUrl(`https://img.cugate.com/?o=CUTV_CATEGORY&i=${category.id}&s=600`)
        }
    }
    , [category])

    const backHandler = () => {
        if(props.changes){
            var answer = window.confirm("You may loose the changes you made");
            if(answer){
                props.setChanges(false)
                navigate(-1)
            }
        } else {
            navigate(-1)
        }
    }


        const handleImage = (e) => {
            setImageFile(e.target.files[0])
            let u = URL.createObjectURL(e.target.files[0])
            setImageUrl(u)
        }
    


    const editGroupHandler = () => {
        if(!title.length){
            alert('Please, Provide Title') 
        } else { 
            const category = {}
            category.title = title
            category.status = statusOn
            category.description = description
            category.description_long = longDescription
            dispatch(editCategory(category_id, category, imageFile ))
            navigate('/categories')
        }
    }

    return (
        <div className = "col-10 p-4" style={{marginLeft:"15vw", minHeight:"100vh"}}>   
            {
                loadingCategory ? <>loading...</> : category ? 
                <> 
                    <div className = "w-100 d-flex flex-column align-items-center pb-5">
                    <div className='col-9 d-flex align-items-center justify-content-start pb-4'>
                        <img 
                            src = {BackIcon} 
                            role = 'button'
                            onClick={backHandler}
                            alt = ""/>
                        <div className = "fw-bold fs-7 ps-4 text-secondary" 
                            role='button' 
                        >{category.title}</div>
                    </div>
                        <div className = "col-9 bg-success me-3 rounded px-3 py-5">
                            <div className = "text-secondary fw-bold pb-2">Title*</div>
                            <input
                                type="text"
                                className="col-12 rounded fs-5 border-0 bg-warning text-white py-3 search-input ps-3"
                                onChange = {(e)=>{setTitle(e.target.value); props.setChanges(true)}}
                                value = {title}
                            />

                            <div className = "text-secondary fw-bold pb-2 pt-4">Description</div>
                                <textarea
                                    type="text"
                                    className="col-12 rounded fs-5 border-0 bg-warning text-white py-2 search-input addToplaylist-list-wrapper ps-3"
                                    style={{height:"5rem", resize:"none"}}
                                    value = {description}
                                    onChange={(e)=>{setDescription(e.target.value)}}
                            />

                            <div className = "text-secondary fw-bold pb-2 pt-4">Long Description</div>
                                <textarea
                                    type="text"
                                    className="col-12 rounded fs-5 border-0 bg-warning text-white py-2 search-input addToplaylist-list-wrapper ps-3"
                                    style={{height:"10rem", resize:"none"}}
                                    value = {longDescription}
                                    onChange={(e)=>{setLongDescription(e.target.value)}}
                            />
                            <div className='w-100 d-flex justify-content-center'>
                            <div className = "bg-warning p-2 mt-3 rounded" style={{width:"40%"}}>
                                <div className = "text-info pb-2">Change Thumbnail</div>
                                {
                                    imageURL ? 
                                    <>
                                        <img src = {imageURL} alt = ""
                                            style = {{width:"100%", aspectRatio:"16/9"}}
                                        />
                                        <div className = "w-100 d-flex justify-content-between align-items-center mt-3">
                                            {
                                                imageFile && imageFile.name ? 
                                                <div className = "text-info w-75 text-decoration-underline text-wrap overflow-hidden">{imageFile.name}</div> : ""
                                            }

                                            <input 
                                                id = "reimage-input"
                                                type="file" 
                                                name="imageFile"
                                                accept='image/jpeg, image/png, image/jpg'
                                                onChange={handleImage}
                                                style={{display:"none"}}
                                                />
                                                <label for="reimage-input">
                                                    <div 
                                                        className = "text-info py-2 px-3 ms-2 bg-success rounded"
                                                        role='button'
                                                    >Change</div>
                                                </label>
                                        </div>
                                    </>
                                    : 
                                    <div className = "w-100 px-3 py-5 bg-warning rounded">
                                        <div className = "w-100 py-5 d-flex bg-secondary justify-content-center">
                                            <input 
                                                id = "image-input"
                                                type="file" 
                                                name="imageFile"
                                                accept='image/jpeg, image/png, image/jpg'
                                                onChange={handleImage}
                                                style={{display:"none"}}
                                                />
                                            <label for="image-input">
                                                <img src = {Attach} alt = "" role="button"/>
                                            </label>
                                        </div>
                                    </div>
                                }
                            </div>
                            </div>
                            <div className = "text-secondary fw-bold pt-4 pb-2">Add Tags</div>
                            <AddTagComponent
                                category_id = {category_id}
                                tags = {categoryTags}
                            />

                            <div className = "text-secondary fw-bold pt-4 pb-2">Tags</div>
                            {
                                loadingCategoryTags ?
                                <div className = "w-100 d-flex justify-content-start align-items-center text-info fs-6">
                                    Loading...
                                </div> :
                                errorCategoryTags ?
                                <div className = "w-100 d-flex justify-content-start align-items-center text-info fs-6">
                                    {errorCategoryTags}
                                </div> :
                                0 === categoryTags.length ?
                                <div className = "w-100 d-flex justify-content-start align-items-center text-info fs-6">
                                    No Tags Found
                                </div> :  
                                <div className = "bg-warning w-100 rounded addToplaylist-list-wrapper" style = {{maxHeight:"500px"}}>
                                {  
                                    categoryTags && categoryTags.length ?
                                        categoryTags.map((tag, index)=>(
                                            <CategoryTagItem
                                                tag = {tag}
                                                category_id = {category_id}
                                                key = {tag.id}
                                            />
                                        )) : ""
                                }

                            </div>  
                            }
                            <div className = "py-4" role = "button">
                                {
                                    statusOn === 0 ? 
                                    <div className = "d-flex align-items-center">
                                        <img src = {SwitchOff} alt = "" onClick={()=>{setStatusOn(1); props.setChanges(true)}}/>
                                        <div className = "text-info ms-4">Access OFF</div>
                                    </div>
                                     : 
                                     <div className = "d-flex align-items-center">
                                        <img src = {SwitchOn} alt = "" onClick={()=>{setStatusOn(0); props.setChanges(true)}}/>
                                        <div className = "text-info ms-4">Access ON</div>
                                    </div>
                                }
                            </div>
                            <div className = "w-100 d-flex justify-content-between">
                                <div 
                                    className = "text-white px-5 py-2 bg-secondary rounded-pill"
                                    role = "button"
                                    onClick = {()=>navigate(`/category/${category.title}/${category.id}`)}
                                >Show Videos</div>
                                <div 
                                    className = "text-white px-5 py-2 bg-secondary rounded-pill"
                                    role = "button"
                                    onClick = {()=>editGroupHandler()}
                                >Save</div>
                            </div>
                        </div>
                    </div>
                </> :                 
                <div className='w-100 h-100 d-flex justify-content-center align-items-center text-info fw-bold fs-4'>
                    There's Some Error, please, try again later
                </div>
            }
        </div>
    );
};

export default EditCategory;